<template>
  <div>
    <div v-if="title==='新增权限'||title==='编辑权限'">
      <label class="col-sm-4  text-lr lh40" >
        <i class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>所属功能模块：</label>
      <el-select v-model="auth_data.parent" placeholder="请选择"  @change="test">
        <el-option
            v-for="item in tableData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div>
      <div class=" row mb-2">
        <label class="col-sm-4  text-lr lh40"><i
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>名称：</label>
        <div class="col-sm-7 flex1 lh35">
          <el-input style="margin-bottom: 0px" size=""
                    v-model=" auth_data.name "  @change="test"
                    placeholder="请输入内容"></el-input>
        </div>
      </div>
    </div>
    <div>
      <div class=" row mb-2">
        <label class="col-sm-4  text-lr lh40"><i

            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>中文名称：</label>
        <div class="col-sm-7 flex1 lh35">
          <el-input style="margin-bottom: 0px" size=""
                    @change="test"
                    v-model=" auth_data.chinese_name "
                    placeholder="请输入内容"></el-input>
        </div>
      </div>
    </div>
    <div v-if="title==='新增权限'||title==='编辑权限'">
      <div class=" row mb-2">
        <label class="col-sm-4  text-lr lh40"><i
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>权限类型：</label>
        <div class="col-sm-7 flex1 lh35">
          <el-select v-model='auth_data.type' placeholder="请选择"
                     value-key="id" clearable  @change="test">
            <el-option v-for="v in options" :key="v.id" :label="v.value" :value="v.value"
                      ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new_auth_dia",
  props:[
      'title'
  ],
  data(){
    return{
      auth_data:this.$store.state.new_auth_data,//从全局里取
      options:[
        {
          value: '新建类',
          id: '1'
        },
        {
          value: '编辑类',
          id: '2'
        },
        {
          value: '查看类',
          id: '3'
        },
        {
          value: '删除类',
          id: '4'
        },  {
          value: '上传类',
          id: '5'
        },  {
          value: '下载类',
          id: '6'
        },  {
          value: '详情类',
          id: '7'
        },  {
          value: '其他类',
          id: '8'
        }

      ],
      tableData:[],
    }
  },
  created() {
    this.query_role_to_func_auth()
  },
  mounted() {
  },
  methods:{
    test(){
      this.$store.commit('set_new_auth_data', this.auth_data)
    },
    //查询权限列表
    query_role_to_func_auth() {
      this.tableData = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params:
            {
              "object_code":'63'
            }
      }).then((response) => {
        for (let i in response.data.content) {
          this.tableData.push({
            'id': response.data.content[i].id,
            'name': response.data.content[i].chinese_name,
          })
          // for (let x in response.data.content[i].children) {
          //   this.tableData[i].children.push(
          //       {
          //         'id': response.data.content[i].children[x].id,
          //         'name': response.data.content[i].children[x].chinese_name,
          //       }
          //   )
          // }
        }
        console.log( this.tableData,' this.tableData')
      })
    },
  },
}
</script>

<style scoped>

</style>